import { zodResolver } from '@hookform/resolvers/zod';
// import { DEFAULT_CONVERSIONS_PERIOD_HOUR } from 'modules/campaigns/lib/constants';
// import { AttributionMode } from 'modules/domains/campaign';
import { FC, PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ObjectKey } from 'utils/tsHelpers';
import { z } from 'zod';
import {
  // MESSAGE_TYPES_FIELD,
  // APPLY_GOAL_TO_FIELD,
  // ApplyGoalTo,
  // ATTRIBUTION_MODE_FIELD,
  // ATTRIBUTION_MODE_HOURS_FIELD,
  // CAMPAIGN_LABELS_FIELD,
  EVENT_NAME_FIELD,
  GOAL_NAME_FIELD,
} from './CreateGoalForm.constants';
import { createGoalSchema } from './CreateGoalFormSchema';

export type CreateGoalFormValues = z.infer<typeof createGoalSchema>;

export const CreateGoalFormProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const methods = useForm<CreateGoalFormValues>({
    defaultValues: {
      [GOAL_NAME_FIELD]: '',
      [EVENT_NAME_FIELD]: '',
      // NOTE: These are not yet supported.
      // [ATTRIBUTION_MODE_FIELD]: AttributionMode.LastMessaged,
      // [ATTRIBUTION_MODE_HOURS_FIELD]: DEFAULT_CONVERSIONS_PERIOD_HOUR.toString(),
      // [APPLY_GOAL_TO_FIELD]: ApplyGoalTo.AllCampaigns,
      // [CAMPAIGN_LABELS_FIELD]: [],
      // [MESSAGE_TYPES_FIELD]: [],
    },
    mode: 'onChange',
    resolver: zodResolver(createGoalSchema),
    shouldUnregister: true,
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};

export const withCreateGoalFormProvider =
  <CreateGoalFormConsumerProps extends Record<ObjectKey, unknown>>(
    CreateGoalFormConsumer: React.FC<CreateGoalFormConsumerProps>,
  ) =>
  (props: CreateGoalFormConsumerProps) => (
    <CreateGoalFormProvider>
      <CreateGoalFormConsumer {...props} />
    </CreateGoalFormProvider>
  );
